module.exports = __webpack_public_path__ + "static/img/DouyinQuechao.fb52053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/DouyinQuechao.jpg
// module id = EUFY
// module chunks = 0